import { render } from "./ComboardDetail.vue?vue&type=template&id=91d7d4d6&scoped=true"
import script from "./ComboardDetail.vue?vue&type=script&lang=js"
export * from "./ComboardDetail.vue?vue&type=script&lang=js"

import "./ComboardDetail.vue?vue&type=style&index=0&id=91d7d4d6&scoped=true&lang=css"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91d7d4d6"]])

export default __exports__